import { EditOutlined } from '@ant-design/icons'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Button from '../../../Components/Button'
import TableBox from '../../../Components/TableBox/TableBox'
import FilterLayout from '../../../Layout/FilterLayout'
import apiClient from '../../../Util/apiClient'
import { GET_DATA, SET_DATA, validateAccess } from '../../../Util/Util'
import AccountGroupFilter from './AccountGroupFilter'

export default function AccountGroups() {
  const [accountGroups, setAccountGroups] = useState([])
  const history = useHistory()

  const onFilter = (params = {}) => {
    apiClient.get('account-groups/get', { params }).then(({ data }) => {
      if (data.result) {
        SET_DATA('accountGroups.filterData', { ...params, ...data.pageData })
        setAccountGroups(data.result)
      }
    })
  }

  useEffect(() => {
    onFilter(GET_DATA('accountGroups.filterData'))
  }, [])

  const onChangePage = (pageData) => {
    const filterCache = GET_DATA('accountGroups.filterData')
    onFilter({ ...(filterCache || {}), ...pageData })
  }

  const columns = [
    {
      title: 'Range Start',
      dataIndex: 'rangeStart'
    },
    {
      title: 'Range End',
      dataIndex: 'rangeEnd'
    },
    {
      title: 'Name',
      dataIndex: 'name'
    },
    {
      title: 'Financial Report',
      dataIndex: 'financialReport'
    },
    {
      title: 'Status',
      dataIndex: 'status'
    },
    {
      ...(validateAccess('edit-account-group') && {
        title: 'Action',
        dataIndex: 'custom_action',
        render: (text, row) => (
          <div className="btn-group">
            <Button
              onClick={() => history.push(`/app/edit-account-group/${row.id}`)}
              className="btn glow dropdown-toggle">
              <EditOutlined />
            </Button>
          </div>
        )
      })
    }
  ]

  return (
    <FilterLayout filter={<AccountGroupFilter onFilter={onFilter} />}>
      <div className="top-filter-options">
        <h2>Account Group Overview</h2>
      </div>
      <TableBox
        dataSource={accountGroups}
        columns={columns}
        pageData={GET_DATA('accountGroups.filterData')}
        onChangePage={onChangePage}
      />
    </FilterLayout>
  )
}
